import React from 'react';
import { Modal, Button, Form, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Close from "../../images/close-icon.svg";
// import DistanceImage from "../../images/nasionimg.png";
import DistanceImage2 from "../../images/preacularimg.png";

const PreauricularModal = ({ showModal, onClose }) => {

  return (
    <Modal
      show={showModal}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="password-modal-content"
      dialogClassName="password-modal-dialog"
    >
      <Link
        variant=""
        onClick={onClose}
        className="modal-close-floating"
        aria-label="Close"
      >
        <Image src={Close} alt="" />
      </Link>

      <Modal.Body className="password-modal-body p-0">
        <div className="head-bg">
          <h5 className="password-modal-title">Preauricular Distance</h5>
        </div>
        <div className="inner-modal-content inner-radius">

          <Image src={DistanceImage2} alt="" className="info-icon" />
          <p className="password-modal-description mt-4">
            The "preauricular to preauricular distance" refers to the measurement of the distance between the left and right  preauricular points, which are located in front of the ears, typically  in the context of EEG electrode placement. This measurement is crucial for establishing the correct placement of  electrodes according to the 10-20 system used in electroencephalography  (EEG).
          </p>



        </div>

      </Modal.Body>
    </Modal>
  );
};

export default PreauricularModal;

